import { appendGuestCountLabel } from '@shared/utils/guestCount';
import { ISOTimeTo12HourTime } from '@shared/utils/time';
import cx from 'classnames';
import typography from '~styles/typography.scss';
import styles from './HeaderBar.scss';

interface HeaderBarProps {
  name: string;
  guestCount: number;
  time?: string;
}

export const HeaderBar = ({ name, guestCount, time }: HeaderBarProps) => (
  <div className={styles.headerBar}>
    <div>
      <p className={cx(typography.h5, styles.guestName)}>{name}</p>

      <p className={cx(typography.t1, styles.guestCount)}>
        {appendGuestCountLabel(guestCount)}
      </p>
    </div>

    {time && <div className={typography.h6}>{ISOTimeTo12HourTime(time)}</div>}
  </div>
);
